/**
 * Created by sumudu on 11/25/16.
 */
(function () {
    angular.module('trainingPrograms')
        .component('assignedTrainerTrainee', {
            templateUrl: 'training-programs/components/training-assigned-trainer-trainee-component.tpl.html',
            controller: function (TrainingAssignCrewModel,TrainingAssignCrewLogic) {
                var vm = this;

                vm.assignedTraineeDetail = null;
                vm.assignedTrainerDetail = null;
                vm.selectedTraining = null;

                vm.$onInit = function () {
                    TrainingAssignCrewModel.assignedTraineeDetail.subscribe(function (assignedTraineeDetail) {
                        vm.assignedTraineeDetail = assignedTraineeDetail;
                    });

                    TrainingAssignCrewModel.assignedTrainerDetail.subscribe(function (assignedTrainerDetail) {
                        vm.assignedTrainerDetail = assignedTrainerDetail && assignedTrainerDetail[0];
                    });

                    TrainingAssignCrewModel.assignedTrainers.subscribe(function (assignedTrainers) {
                        vm.assignedTrainers = assignedTrainers;
                    });

                    TrainingAssignCrewModel.selectedTraining.subscribe(function (training) {
                        vm.selectedTraining = training;
                    });
                };

                vm.onUnassignClick = function (crew) {
                    var slotId = vm.selectedTraining && vm.selectedTraining.trainingSlotID;
                    TrainingAssignCrewLogic.unAssignCrew(crew.profileId,crew.crewSchdBlockId,slotId);
                };

                vm.otherHubUnAssignClick = function (crew) {
                  TrainingAssignCrewLogic.otherHubUnAssignCrew(crew.otherHub);
                };

            },
            bindings: {}
        });
})();
